import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=2944eafc&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2944eafc')) {
      api.createRecord('2944eafc', component.options)
    } else {
      api.reload('2944eafc', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=2944eafc&", function () {
      api.rerender('2944eafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yo0elvf8uTWF/JS/comp/stardisplay.vue"
export default component.exports